<template>
  <div
    data-testid="hot-destinations-city-card"
    @click="clickCard"
    :class="['hot-destinations-city-card', 'pointer', state]"
    :style="`background-image: url(${imagePolicy})`"
  >
    <div class="title">
      <h3 class="title--main">
        {{ name }}
      </h3>
      <div class="title--hotels">{{ numHotels }} Hotels</div>
    </div>

    <div class="subtitle">
      <div v-if="priceWithAmount || !priceFrom" class="subtitle--from">
        {{ translate('from') }}
      </div>
      <div class="subtitle--price">
        {{ hotelStatus }}
      </div>
    </div>
  </div>
</template>

<script>
import { defaultImage } from '../../infrastructure/Configuration'

export default {
  name: 'HostDestinationsCityCard',
  props: {
    name: {
      type: String,
      required: true
    },
    numHotels: {
      type: Number,
      required: true
    },
    priceFrom: {
      type: Object
    },
    state: {
      type: String
    },
    image: {
      type: Object,
      default: () => ({
        url: defaultImage(),
        altText: ''
      })
    }
  },
  computed: {
    priceWithAmount() {
      return this.priceFrom && this.priceFrom?.amount !== 0
    },
    priceWithAmountZero() {
      return this.priceFrom && this.priceFrom?.amount === 0
    },
    priceFromFormatted() {
      return this.priceFrom && this.priceFrom?.formattedAmount
    },
    hotelStatus() {
      if (this.priceWithAmountZero) {
        return this.translate('offMapSoldOut')
      } else if (this.priceWithAmount) {
        return this.priceFromFormatted
      } else {
        return this.translate('offLoading')
      }
    },
    imagePolicy() {
      return `${this.image.url}?impolicy=Card`
    }
  },
  methods: {
    clickCard() {
      this.$emit('click-card')
    }
  }
}
</script>

<style scoped lang="scss">
.hot-destinations-city-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  width: 100%;
  height: 228px;
  background: linear-gradient(0.95deg, rgba(0, 0, 0, 0.7) 1.28%, rgba(0, 0, 0, 0) 99.67%);
  border-radius: 10px;
  background-size: cover;
}
.hot-destinations-city-card:hover {
  filter: drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.2));
}

.disabled-card:hover {
  filter: none;
}
.disabled-card {
  opacity: 0.5;
}
.selected-card {
  border: 2px solid var(--color-premium);
}

.title {
  align-self: start;
  color: var(--color-white);
  font-style: normal;
  font-weight: 700;
  text-shadow: 0 1px 3px black;
  &--main {
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &--hotels {
    font-size: 14px;
    line-height: 13px;
    margin-top: 1rem;
  }
}

.subtitle {
  align-self: end;
  font-style: normal;
  color: var(--color-white);
  text-shadow: 0 1px 3px black;
  &--from {
    font-weight: 350;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
  }
  &--price {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
  }
}
.pointer {
  cursor: pointer;
}
</style>
